import {
  Body,
  Button,
  Container,
  Row,
  Head,
  Html,
  Img,
  Preview,
  Section,
  Text,
  Heading,
} from '@react-email/components';
import React, { FC } from 'react';

export interface Props {
  buttonLink?: string;
  buttonText?: string;
  paragraphs?: string[];
  footerParagraphs?: string[];
  notes?: string;
  hostname?: string;
  subject: string;
}

const EmailTemplate: FC<Props> = ({
  buttonLink,
  buttonText,
  notes,
  footerParagraphs,
  paragraphs,
  hostname,
  subject,
}) => {
  return (
    <Html>
      <style>
        {`
          b, strong { font-weight: bold; }
        `}
      </style>
      <Head />
      <Body style={main}>
        <Preview>{subject}</Preview>
        <Container style={container}>
          <Img src={`https://${hostname}/assets/logo.png`} height="33" />
          <Section>
            {paragraphs?.map((paragraph, index) => (
              <Text key={index} style={text} dangerouslySetInnerHTML={{ __html: paragraph }} />
            ))}

            {buttonLink && (
              <Button style={button} href={buttonLink}>
                {buttonText || 'Click Here'}
              </Button>
            )}

            {footerParagraphs?.map((footer, index) => (
              <Text key={index} style={text}>
                {footer}
              </Text>
            ))}

            {notes && (
              <div style={note}>
                <Heading style={noSpacing} as="h4">
                  Note:
                </Heading>
                <Text style={noSpacing} dangerouslySetInnerHTML={{ __html: notes }}></Text>
              </div>
            )}
          </Section>
        </Container>
        <Section style={footer}>
          <Row>
            <Text style={{ textAlign: 'center', color: '#706a7b' }}>© 2025 My Airway Exam, All Rights Reserved</Text>
          </Row>
        </Section>
      </Body>
    </Html>
  );
};

export default EmailTemplate;

const footer = {
  maxWidth: '580px',
  margin: '0 auto',
};

const main = {
  backgroundColor: '#f6f9fc',
  padding: '10px 0',
};

const container = {
  backgroundColor: '#ffffff',
  border: '1px solid #f0f0f0',
  padding: '45px',
};

const text = {
  fontSize: '16px',
  fontFamily:
    "'Open Sans', 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, 'Lucida Grande', sans-serif",
  fontWeight: '300',
  color: '#404040',
  lineHeight: '26px',
  '& strong, & b': {
    fontWeight: '600',
  },
  '& h1': {
    fontSize: '24px',
    fontWeight: '600',
    margin: '0 0 10px',
  },
  '& h2': {
    fontSize: '20px',
    fontWeight: '600',
    margin: '0 0 10px',
  },
  '& h3': {
    fontSize: '18px',
    fontWeight: '600',
    margin: '0 0 10px',
  },
};

const button = {
  backgroundColor: '#007ee6',
  margin: 'auto',
  borderRadius: '4px',
  color: '#fff',
  fontFamily: "'Open Sans', 'Helvetica Neue', Arial",
  fontSize: '15px',
  textDecoration: 'none',
  textAlign: 'center' as const,
  display: 'block',
  fontWeight: '600',
  width: '210px',
  padding: '14px 7px',
};

const note = {
  backgroundColor: '#f6f9fc',
  padding: '10px',
  borderRadius: '4px',
  fontSize: '14px',
  marginTop: '20px',
};

const noSpacing = {
  margin: 0,
  padding: 0,
};
